/* eslint-disable */
import type { Dispatch } from 'react';
import type { DealerContextServiceV1, DealerId } from '@oneaudi/dealer-context-service';
import { parsePartnerId } from './parsePartnerId';
import type { Action } from '../contexts/reducers/map-reducer';
import { ActionTypes } from '../contexts/reducers/map-reducer';
import {
  DEALER_CONTEXT_AUTOCONNECT_UNSUBSCRIBE,
  DEALER_CONTEXT_UNSUBSCRIBE,
  KEY_DEALER_DATA,
} from './globals';

export const connectDealerToDealerContext = (
  partnerId: string,
  dealerContextService: DealerContextServiceV1,
  dispatch: Dispatch<Action>,
) => {
  if (!partnerId) return;

  const connectedDealer: string | null = parseConnectedDealer(
    dealerContextService.getSelectedDealer() as DealerId,
  );

  if (connectedDealer !== partnerId) {
    const parsedPartnerId = parsePartnerId(partnerId);
    dealerContextService.setSelectedDealer(parsedPartnerId);
    updateQueryParam('partner_id', partnerId);
    dispatch({ type: ActionTypes.setConnectedDealer, payload: partnerId });
  }
};

export const disconnectDealerFromDealerContext = (
  dealerContextService: DealerContextServiceV1,
  dispatch: Dispatch<Action>,
  autoConnectDealer: boolean,
) => {
  dealerContextService.setSelectedDealer(undefined);

  deleteQueryParam('partner_id');

  dispatch({ type: ActionTypes.setConnectedDealer, payload: null });

  if (autoConnectDealer && typeof window !== 'undefined') {
    sessionStorage.setItem(KEY_DEALER_DATA, DEALER_CONTEXT_UNSUBSCRIBE);
    sessionStorage.setItem(DEALER_CONTEXT_AUTOCONNECT_UNSUBSCRIBE, 'true');
  }
};

export const parseConnectedDealer = (dealerContextService: DealerId) => {
  if (
    dealerContextService &&
    dealerContextService.market &&
    dealerContextService.brand &&
    dealerContextService.id
  )
    return `${dealerContextService.market}${dealerContextService.brand}${dealerContextService.id}`;
  return null;
};

const updateQueryParam = (key: string, value: string) => {
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.replaceState({}, '', url.toString());
};

const deleteQueryParam = (key: string) => {
  const url = new URL(window.location.href);
  url.searchParams.delete(key);
  window.history.replaceState({}, '', url.toString());
};
